import React from 'react'
import "./SidebarList.css"
import profilePic from '../images/kheyre.jpeg'
import { FcHome, FcNightPortrait, FcTodoList, FcRules, FcContacts, FcFactory, FcSalesPerformance } from "react-icons/fc";
import { MdBiotech, MdCastForEducation } from "react-icons/md";
import { Link } from "react-scroll"


const SidebarList = ({ expnadSidbar }) => {
  return (
    <>

      {expnadSidbar ? (
        <div className="navbar-items">

          <div className="sidebar-profile-pic">
            <img src={profilePic} alt="profile picture" />
          </div>

          <ul>
            <li className='nav-item'>
              <Link
                to='home'
                spy={true}
                smooth={true}
                duration={100}
                offset={-100}
              >
                <FcHome size={20} />
                Home </Link> </li>
            <li className='nav-item'>
              <Link

                to='about'
                spy={true}
                smooth={true}
                duration={100}
                offset={-100}
              >
                <FcNightPortrait size={20} /> About
              </Link>
            </li>
            <li className='nav-item'>

              <Link
                to='techStack'
                spy={true}
                smooth={true}
                duration={100}
                offset={-100}
              >
                <MdBiotech size={20} />Tech Stack
              </Link>

            </li>
            <li className='nav-item'>
              <Link

                to='project'
                spy={true}
                smooth={true}
                duration={100}
                offset={-100}
              >
                <FcTodoList size={20} /> Porjects
              </Link>

            </li>
            <li className='nav-item'>

              <Link

                to='expriance'
                spy={true}
                smooth={true}
                duration={100}
                offset={-100}
              >
                <FcFactory size={20} /> Experiance
              </Link>

            </li>
            <li className='nav-item'>

              <Link
                to='education'
                spy={true}
                smooth={true}
                duration={100}
                offset={-100}
              >
                <MdCastForEducation size={20} /> Education
              </Link>


            </li>
            <li className='nav-item'>

              <Link
                to='testimonial'
                spy={true}
                smooth={true}
                duration={100}
                offset={-100}
              >
                <FcRules size={20} /> Testmonial
              </Link>


            </li>
            <li className='nav-item'>

              <Link
                to='contactid'
                spy={true}
                smooth={true}
                duration={100}
                offset={-100}
              >
                <FcContacts size={20} /> Contact
              </Link>

            </li>


          </ul>

        </div>

      ) : <div className='navbar-items-only-icons'>


        <ul>
          <li className='nav-item'>
            <Link
              to='home'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <FcHome size={20} />
                </Link> </li>
          <li className='nav-item'>
            <Link

              to='about'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <FcNightPortrait size={20} />
            </Link>
          </li>
          <li className='nav-item'>

            <Link
              to='techStack'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <MdBiotech size={20} color="yellow"/>
            </Link>

          </li>
          <li className='nav-item'>
            <Link

              to='project'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <FcTodoList size={20} />
            </Link>

          </li>
          <li className='nav-item'>

            <Link

              to='expriance'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <FcFactory size={20} />
            </Link>

          </li>
          <li className='nav-item'>

            <Link
              to='education'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <MdCastForEducation size={20} color="white" />
            </Link>


          </li>
          <li className='nav-item'>

            <Link
              to='testimonial'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <FcRules size={20} />
            </Link>


          </li>
          <li className='nav-item'>

            <Link
              to='contactid'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <FcContacts size={20} />
            </Link>

          </li>


        </ul>
      </div>}


    </>
  )
}

export default SidebarList